module.exports = require('./dist/brand/brand.js');
